var pbkdf2 = require('pbkdf2-sha256')

export default function getPdkdSign(url) {
  const appId = "d83kd93k2b9d916"
  const appSecret = "a3jh2rj46hktg690bfdasjd0s0d87fc"
  const timestamp = parseInt(Date.parse(new Date()) / 1000)
  const nonce_divisor = 99
  const src = "lexar"+appSecret+timestamp
  const iterations = (timestamp % nonce_divisor) + 1  // 取余 1-99次
  const dk = pbkdf2(src, appSecret, iterations, 64)
  const sign = dk.toString('base64').replace(/\+/g, '-').replace(/\//g, "_")


  return {
    options: {
      'X-API-SIGN': sign
    },
    timestamp,
    appId,
    url: `${url}?appId=${appId}&timestamp=${timestamp}`
  }
}


// WEBPACK FOOTER //
// ./src/utils/sign.js